import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.72901 2C5.49732 2 4.39078 2.75284 3.93855 3.8985L2.6094 7.26567C2.15107 8.42676 2.85526 9.67344 4.00073 9.94559C4.00025 9.96367 4 9.98181 4 10V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V10C20 9.98179 19.9998 9.96364 19.9993 9.94554C21.1446 9.67327 21.8487 8.42669 21.3904 7.26567L20.0612 3.8985C19.609 2.75284 18.5024 2 17.2708 2H6.72901ZM18 10H6V20H7.17071C7.06015 19.6872 7 19.3506 7 19V15C7 13.3431 8.34315 12 10 12H14C15.6569 12 17 13.3431 17 15V19C17 19.3506 16.9398 19.6872 16.8293 20H18V10ZM19.5301 8L18.2009 4.63283C18.0502 4.25095 17.6813 4 17.2708 4H6.72901C6.31845 4 5.9496 4.25095 5.79886 4.63283L4.46971 8L19.5301 8ZM9 15C9 14.4477 9.44772 14 10 14V15C10 15.5523 10.4477 16 11 16H13C13.5523 16 14 15.5523 14 15V14C14.5523 14 15 14.4477 15 15V19C15 19.5523 14.5523 20 14 20H10C9.44772 20 9 19.5523 9 19V15Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}